import { Moment } from '@e3dc-react/shell/Libs/moment'
import type { ChartView } from '../../shared/utils/chartModel'
import { useMediaQuery } from '@mui/system'
import { useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { AxisInterval } from 'recharts/types/util/types'
import { generateNormalAxisConfig, generateZoomedAxisConfig, getInterval } from '../utils'

export interface useXAxisReturnType {
  ticks: number[]
  format: string
  interval?: AxisInterval
}

/**
 * Returns the x-axis ticks, their format and the interval based on the given date range and view
 */
const useXAxisTicks = (from: Moment, to: Moment, view: ChartView, isZoomedIn?: boolean, isCustomRangeEnabled?: boolean): useXAxisReturnType => {
  const theme = useTheme()
  const isUpTiny = useMediaQuery(theme.breakpoints.up(380))
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'))
  const isUpMd = useMediaQuery(theme.breakpoints.up('md'))
  const [ticks, setTicks] = useState<number[]>([])
  const [interval, setInterval] = useState<AxisInterval | undefined>()
  const [format, setFormat] = useState<string>('')

  useEffect(() => {
    setInterval(getInterval(view))
  }, [view])

  useEffect(() => {
    if (isZoomedIn) {
      const { ticks, format } = generateZoomedAxisConfig(from, to, view, isUpMd, isUpSm, isUpTiny)
      setTicks(ticks)
      setFormat(format)
    } else {
      const { ticks, format } = generateNormalAxisConfig(from, to, view, isUpMd, isUpSm, isUpTiny, isCustomRangeEnabled)
      setTicks(ticks)
      setFormat(format)
    }
  }, [from, to, view, isUpSm, isUpTiny, isUpMd, isZoomedIn, isCustomRangeEnabled])

  return { ticks, format, interval }
}

export default useXAxisTicks
